export const isLocalHost = window.location.href.split(":").length > 2;
export const isDev =
  isLocalHost || window.location.href.split(/\/|:|\.|-/).includes("dev");
export const isPartnerDev =
  isDev && window.location.href.includes("eat-togo.com");
export const isDeveloperDev =
  isDev && !window.location.href.includes("eat-togo.com");

export const exeDevOrProd = (devFn, devArgs, prodFn, prodArgs) => {
  return isDev ? devFn(...devArgs) : prodFn(...prodArgs);
};
export const logInDev = (...devArgs) =>
  exeDevOrProd(console.log, ["dev", ...devArgs], console.log, []);

export const showComponentInDev = (C) => (isDev ? C : null);
